import { render, staticRenderFns } from "./EditModuleView.vue?vue&type=template&id=4a4d94d2"
import script from "./EditModuleView.vue?vue&type=script&lang=js"
export * from "./EditModuleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports